export const load = () => ({
	h1: 'Third Party Research and Performance Data',
	title: 'Third Party Research and Performance Data on Indow Window Inserts',
	description:
		'See industry experts, third party studies, and performance on Indow sounproofing, insulating, energy efficiency, light blocking, and more.',
	showTitle: true,
});
